/** @format */

import { useEffect, useState, useMemo } from "react";
import { Spinner, Table, Container } from "reactstrap";
import http from "../../../services/http";
import { getAPIURL, getVendorSettings } from "../../../services/helper";
import EODHeader from "./EODHeader";

const api_url = getAPIURL();

export default function EODByCategory({ register_id }) {
  const vendor_store_name = getVendorSettings("name");
  const vendor_address = getVendorSettings("vendor_contact_address");
  const vendor_phone = getVendorSettings("vendor_contact_phone");

  const [register, setRegister] = useState(null);
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchRegisterReport();
  }, []);

  const fetchRegisterReport = async () => {
    setLoading(true);
    try {
      const { data } = await http.get(
        `${api_url}/reports/close/detail/${register_id}`
      );
      setRegister(data);
      setTransactions(data.transactions || []);
    } catch (error) {
      console.error("Error fetching register report:", error);
    }
    setLoading(false);
  };

  const categoryReport = useMemo(() => {
    const summary = {};

    (transactions || []).forEach((txn) => {
      const tax = parseFloat(txn.tax_collected || 0);
      const discount = parseFloat(txn.discount || 0);

      txn.products.forEach((prod) => {
        const category = prod.category?.name || "Uncategorized";
        const price = parseFloat(prod.price || 0);
        const qty = parseFloat(prod.qty || 0);
        const total = price * qty;

        if (!summary[category]) {
          summary[category] = {
            sales: 0,
            discounts: 0,
            tax: 0,
            total: 0,
          };
        }

        summary[category].sales += total;
        summary[category].discounts += discount;
        summary[category].tax += tax;
        summary[category].total += total + tax + discount;
      });
    });

    return Object.entries(summary).map(([category, values]) => ({
      category,
      ...values,
    }));
  }, [transactions]);

  if (loading || !register) return <Spinner color="primary" />;

  return (
    <div className="page-body">
      <Container className="mt-4">
        {/* Back Button */}
        <EODHeader
          closed_at={register.closed_at}
          printLink={`/print/reports/eod-category/${register_id}`}
        />

        <hr />

        {/* Category Report */}
        <div className="eod-category-report mt-5">
          <h4 className="text-center mb-3">End of Day Summary by Category</h4>
          <Table bordered responsive striped>
            <thead>
              <tr>
                <th>Category</th>
                <th>Sales</th>
                <th>Discounts</th>
                <th>Tax</th>
                <th>Total</th>
              </tr>
            </thead>
            <tbody>
              {categoryReport.map((cat, i) => (
                <tr key={i}>
                  <td>{cat.category}</td>
                  <td>${cat.sales.toFixed(2)}</td>
                  <td>${cat.discounts.toFixed(2)}</td>
                  <td>${cat.tax.toFixed(2)}</td>
                  <td>${cat.total.toFixed(2)}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </Container>
    </div>
  );
}
